import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Games/Table";
import RoleViewModel from "../../Components/Games/ViewModel";

import Navbar from "../../Components/Navbar";
import DeleteModal from "../../Components/Games/DeleteModel";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { SmallBtn } from "../../Components/Styles/InputStyles";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import UpdateStatusModel from "../../Components/Games/UpdateStatusModel";
import AddModel from "../../Components/Games/AddModel";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";

const Games = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [deleteModel, setDeleteModel] = useState(false);

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openUpdateModel, setOpenUpdateModel] = useState(false);

  const [openRoleViewModel, setopenRoleViewModel] = useState(false);
  const [selectedData, setSelectedData] = useState("");

  const [editUser, setEditUser] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  //const isLoadingFetch = "";
  //const error = "";
  //const refetch = "";
  //const isRefetching = "";

  // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("type", 6);
    return await axios.post(`${Config.apiUrl}/listgames`, 
    body, 
    {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const { isLoadingFetch, error, data, refetch, isRefetchingFetch } = useQuery(
    "userList",
    fetchFunction
  );
  //console.log(data);

  //------ Upload Excel File ------
  const postFunction = async (file) => {
    if (file !== null && file !== undefined) {
      const body = new FormData();
      body.append("file", file[0]);

      return await axios.post(Config.AdminUploadApi, body, {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    } else throw Error("error");
  };

  const onSuccess = (data) => {
    refetch();
    setOpenUploadModel(false);
  };

  const onError = (data) => {
    setOpenUploadModel(false);
  };

  const { isLoading: uploadLoading, mutate: uploadExcelFile } = useMutation(
    postFunction,
    { onSuccess, onError }
  );

  //------- Add Single Entry -------
  const AddUserPostFunction = async (values) => {
    console.log(values);
    const body = new FormData();
    body.append("name", values.name);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("password", values.password);
    return await axios.post(
      `${Config.apiUrl}/addgame`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  }

  const onAddUserSuccess = (data) => {
    //console.log(data);
    if (data?.data?.status == 'OK')
    {
      toast.success(data?.data?.msg || "Success");
      refetch();
    }
    else
    {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setOpenUploadModel(false);
  };

  const onAddUserError = (data) => {
    //console.log(data);
    setOpenUploadModel(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: AddUserLoading, mutate: postAddUser } =
    useMutation(AddUserPostFunction, {
      onSuccess: onAddUserSuccess,
      onError: onAddUserError,
    });

  //------- Edit Single Entry -------
  const editStatusFunction = async (values) =>
  {
    const body = new FormData();
    body.append("id", values.id);
    body.append("status", values.status);
    body.append("userType", 6);

    return await axios.post(
      `${Config.apiUrl}/editgamestatus`,
      body,
      {
        headers: {
          authorization: user.token, //token is not in inspect
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  }

  const onEditEntrySuccess = (data) => {

    if (data?.data?.status == 'OK')
    {
      toast.success(data?.data?.msg || "Success");
      refetch();
    }
    else
    {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setOpenUpdateModel(false);
  };

  const onEditEntryError = (data) => {
    setOpenUpdateModel(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");

  };

  const { isLoading: editEntryLoading, mutate: editAddUser } = useMutation(
    editStatusFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    }
  );

  // change password
  const changePasswordFunction = async (values) =>{
    const body = new FormData();
    body.append("gameId", values.id);
    return await axios.post(
      Config.apiUrl + "/deletegame",
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );}

  const onChangePasswordSuccess = (data) => {
    toast.success(data?.data?.msg, "Success");
    setDeleteModel(false);
  };

  const onChangePasswordError = (data) => {
    toast.error(data?.response?.data?.msg, "An Error Occured");
  };

  const { mutate: changePasswordMutate, isLoading: changePasswordLoading } =
    useMutation(changePasswordFunction, {
      onSuccess: onChangePasswordSuccess,
      onError: onChangePasswordError,
    });


  return (
    <>
    <Navbar />
    {deleteModel && (
          <DeleteModal
            setDeleteModel={setDeleteModel}
            deleteDeviceLoading={changePasswordLoading}
            deleteDeviceMutate={changePasswordMutate}
            deviceId={setSelectedData}
          />
        )}
    <Page>
      <BoxContainer>
        <div className="flex w-full justify-between items-center">
          <div>
            <Title>Games</Title>
            <Underline />
          </div>

          <Uploader setOpenUploadModel={setOpenUploadModel} />
        </div>

      
        {openUploadModel && (
          <AddModel
            postAddUser={postAddUser}
            AddUserLoading={AddUserLoading}
            setOpenUploadModel={setOpenUploadModel}
          />
        )}

        {openUpdateModel && (
          <UpdateStatusModel
            postUpdateStatus={editAddUser}
            setOpenUpdateStatusModel={setOpenUpdateModel}
            editEntryLoading={editEntryLoading}
            setEditUser={setEditUser}
            selectedData={selectedData}
          />
        )}
        {/* 
        {!isLoading && !isRefetching && (
          <TableWrapper>
            <AdminTable
              ApiData={error ? [] : data?.data}
              setopenRoleViewModel={setopenRoleViewModel}
              setSelectedData={setSelectedData}
              setEditUser={setEditUser}
            />
          </TableWrapper>
        )} */}

        <TableWrapper>
          <Table
            ApiData={error ? [] : data?.data?.list}
            setOpenUpdateModel={setOpenUpdateModel}
            setSelectedData={setSelectedData}
            setEditUser={setEditUser}
            setDeleteModel={setDeleteModel}

          />
        </TableWrapper>

        {/* {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />} */}
      </BoxContainer>
    </Page>
    </>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Add Game</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default Games;
